module.exports = __webpack_public_path__ + "img/Cabo Verde.67fd6b74.gif";